import { t } from 'i18next'
import Carousel from './CustomCarousel'
import { Item } from '../../../../../store/types'
import i18n from '../../../../../config/i18n'
import { environment } from '../../../../../enviroments/enviroment'

const translationBase = 'components.infoSidebar.schedule.carousel.plan'
const urlBase = `${environment.publicUrl}/assets/image/carousel/info/plan`

const LIGHT_PL_1 = `${urlBase}/plan-light-PL-1.png`
const LIGHT_PL_2 = `${urlBase}/plan-light-PL-2.png`
const LIGHT_PL_3 = `${urlBase}/plan-light-PL-3.png`

const DARK_PL_1 = `${urlBase}/plan-dark-PL-1.png`
const DARK_PL_2 = `${urlBase}/plan-dark-PL-2.png`
const DARK_PL_3 = `${urlBase}/plan-dark-PL-3.png`

const LIGHT_EN_1 = `${urlBase}/plan-light-EN-1.png`
const LIGHT_EN_2 = `${urlBase}/plan-light-EN-2.png`
const LIGHT_EN_3 = `${urlBase}/plan-light-EN-3.png`

const DARK_EN_1 = `${urlBase}/plan-dark-EN-1.png`
const DARK_EN_2 = `${urlBase}/plan-dark-EN-2.png`
const DARK_EN_3 = `${urlBase}/plan-dark-EN-3.png`

const PlanCarousel = () => {
  const isPolish = i18n.language === 'pl'
  const items: Item[] = [
    {
      subtitle: t(`${translationBase}.details.subtitle`),
      description: t(`${translationBase}.details.description`),
      imageLight: isPolish ? LIGHT_PL_1 : LIGHT_EN_1,
      imageDark: isPolish ? DARK_PL_1 : DARK_EN_1,
      key: 'carousel-schedule-info-plan-1',
    },
    {
      subtitle: t(`${translationBase}.timePeriods.subtitle`),
      description: t(`${translationBase}.timePeriods.description`),
      imageLight: isPolish ? LIGHT_PL_2 : LIGHT_EN_2,
      imageDark: isPolish ? DARK_PL_2 : DARK_EN_2,
      key: 'carousel-schedule-info-plan-2',
    },
    {
      subtitle: t(`${translationBase}.overlappingPeriods.subtitle`),
      description: t(`${translationBase}.overlappingPeriods.description`),
      imageLight: isPolish ? LIGHT_PL_3 : LIGHT_EN_3,
      imageDark: isPolish ? DARK_PL_3 : DARK_EN_3,
      key: 'carousel-schedule-info-plan-3',
    }
  ]

  return <Carousel title={t(`${translationBase}.title`)} items={items} />
}

export default PlanCarousel
